export default "__VITE_ASSET__BKyjLisS__"